import GradientBorder from "@core-components/gradient-border/GradientBorder";
import { Button, Group } from "@mantine/core";
import type { ReactNode } from "react";

interface IPaymentMethodProps {
  children: ReactNode;
  icon: ReactNode;
  isChosen: boolean;
  onChoose: () => void;
}

const PaymentMethod: React.FC<IPaymentMethodProps> = ({
  children,
  icon,
  isChosen,
  onChoose,
}) => {
  if (isChosen)
    return (
      <GradientBorder className="hover-scale gradient-purple-blue z-10 rounded-lg">
        <Button
          onClick={() => onChoose()}
          className={
            "h-fit w-full cursor-pointer select-none rounded-lg bg-chosen p-0 hover:bg-chosen disabled:cursor-not-allowed"
          }
          classNames={{
            inner: "h-fit",
            label: "flex-1 p-5 text-sm",
          }}
        >
          <Group justify="space-between" className="flex-1">
            <Group>{children}</Group>
            {icon}
          </Group>
        </Button>
      </GradientBorder>
    );

  const method = (
    <Button
      onClick={() => onChoose()}
      className={
        "hover-scale h-fit cursor-pointer select-none rounded-lg bg-primary-default p-0 hover:bg-primary-light disabled:cursor-not-allowed"
      }
      classNames={{
        inner: "h-fit",
        label: "flex-1 p-5 text-sm",
      }}
    >
      <Group justify="space-between" className="flex-1">
        <Group>{children}</Group>
        {icon}
      </Group>
    </Button>
  );

  return method;
};

export default PaymentMethod;
